import { render, staticRenderFns } from "./OrganisationsPage.vue?vue&type=template&id=9a93d89e&"
import script from "./OrganisationsPage.vue?vue&type=script&lang=ts&"
export * from "./OrganisationsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports